// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c9ce092","246":"a69ce94e","455":"e11d81dd","488":"da506c94","977":"d52f7874"}[chunkId] + ".chunk.js";
};